<template>
  <li>
    <MenuItem :item="link" :has-items="Boolean(items?.length)" @open="isOpen = true" />
    <Transition
      v-if="items?.length"
      enter-active-class="transition-transform duration-300"
      leave-active-class="transition-transform duration-300"
      enter-from-class="translate-x-full"
      leave-to-class="translate-x-full"
    >
      <div
        v-show="isOpen"
        class="absolute top-0 z-10 w-full min-h-full bg-gray-50 md:overflow-y-auto"
      >
        <div class="px-8 mb-2">
          <BackButton class="mt-4" @back="isOpen = false" />
          <p v-if="link.label" class="flex font-bold text-20 tracking-wider mt-2">
            {{ link.label }}
          </p>
          <a
            v-if="subLabelMobile"
            class="underline cursor-pointer text-16 font-medium text-red-400"
            :href="link.link ?? undefined"
            @click="trackClickout"
          >
            {{ subLabelMobile }}
          </a>
          <MenuCta v-if="showMenuCta" />
        </div>
        <ul class="min-h-full">
          <template v-if="highlights?.length">
            <li v-for="(highlight, index) in highlights" :key="`highlight-${index}`">
              <MenuItem :item="highlight" />
            </li>
          </template>
          <MenuContent
            v-for="(el, index) in items"
            :key="`item-${index}`"
            :link="'items' in el ? el.link : el"
            :items="'items' in el ? el.items : null"
            :sub-label-mobile="'subLabelMobile' in el ? el.subLabelMobile : null"
          />
        </ul>
      </div>
    </Transition>
  </li>
</template>

<script lang="ts" setup>
import { NavigationItemClick } from '@core/analytics/core-events/navigation'
import type { GQLNavigationItem } from './generated/page-header'
import MenuItem from './menu-item.vue'
import MenuCta from './menu-cta.vue'

const props = defineProps<{
  link: GQLNavigationItem['link']
  highlights?: Array<GQLNavigationItem['link']> | null
  items?: NonNullable<GQLNavigationItem['items']> | Array<GQLNavigationItem['link']> | null
  subLabelMobile?: string | null
  id?: string
}>()

const { $track } = useNuxtApp()

const isOpen = ref(false)

const showMenuCta = computed(() => props.id === 'money-transfer-comparison')

async function trackClickout() {
  await $track(NavigationItemClick(props.link.link, 'header'))
}
</script>
